import Loader from "components/Loader/Loader";
import TableRow from "./TableRow";
import TableFooter from "./TableFooter";
import { useSelector } from "react-redux";
import { getExpensesList, selectState, setSort } from "../main.slice";
import { useAppDispatch } from "hooks/hooks";
import { useEffect } from "react";
import DeleteExpenseModal from "./DeleteExpenseModal";
import { useProjectOptions } from "Dashboard/hooks/ProjectsOptions";

const TopSection = () => {
  const { loading, expenses } = useSelector(selectState);
  const dispatch = useAppDispatch();
  const projects = useProjectOptions({ showHiddenInDropDowns: true });

  useEffect(() => {
    dispatch(getExpensesList());
  }, [dispatch]);

  const handleSort = (
    sortKey: string, typeOfValue: 'string' | 'boolean' | 'date'
  ) => {
    dispatch(setSort({ key: sortKey, typeOfValue: typeOfValue }));
  };

  return (
    <section className="loading-container">
      {loading && <Loader />}
      <div className="g-grid g-header">
        <div className="row">
          <div className="col"></div>
          <div className="col capitalize separator-line clickable"
            onClick={() => handleSort("title", "string")}>Ime
          </div>
          <div className="col"></div>
          <div className="col noTextTransform center separator-line">
            Za projekat
          </div>
          <div className="col capitalize center separator-line clickable"
            onClick={() => handleSort("date", "date")}>Datum
          </div>
          <div className="col noTextTransform center separator-line">
            Datum poslednje up.
          </div>
          <div className="col uppercase center separator-line">IZNOS</div>
        </div>
      </div>

      <div className="g-grid g-content">
        {expenses.expenses &&
          expenses.expenses.map((expense, index) => (
            <TableRow expense={expense} key={expense.expenseId} index={index} projects={projects} />
          ))}
      </div>
      <DeleteExpenseModal />

      <div className="g-grid g-footer">
        <TableFooter expensesCount={expenses.expensesCount}
          totalAmountPaid={expenses.totalAmountPaid} />
      </div>

    </section>
  );
};

export default TopSection;
